require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-is-good-and-what-is-missing-in-the-new-world.json") })
        }
      }, "path---en-us-update-what-is-good-and-what-is-missing-in-the-new-world");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-is-good-and-what-is-missing-in-the-new-world!./.cache/json/en-us-update-what-is-good-and-what-is-missing-in-the-new-world.json
// module id = 842
// module chunks = 231608221292675